const data = {
  primaryColor: "#009688",
  lightColor: false,
  title: "Identity",
  category: "Internal Tools",
  icon: "/images/app-icons/identity.png",
  slogan: "Authentication, registration and managing user account",
  shortDescription: "",
  fullDescription:
    "Web application for registering new users, login current users, resetting forgotten password, deleting account, getting details about account and authentication users in APIs",
  usesCases: [
    "User can authenticate to my ecosystem of apps",
    "User can create account in my ecosystem of apps",
    "User can get detailed information about his account",
    "User can change password or delete his account",
  ],
  properties: [
    "Login current users",
    "Register new users",
    "Reset password",
    "Changing password",
    "Authentication of users in other applications developed by me",
    "Detail information about user's account",
    "Deleting account",
  ],
  services: [],
  android: null,
  frontend: {
    url: null,
    versioning: {
      releasedOn: null,
      currentVersion: "0.0.9-beta",
      updatedOn: null,
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    responsivenessCompatibility: {
      phone: true,
      tablet: true,
      desktop: true,
    },
    techInformation: {
      language: "JavaScript",
      framework: "ReactJS",
      integrations: [],
      packageManager: "npm",
      webServer: "Nginx",
      virtualization: "Docker container",
      containerOS: "Alpine Linux",
      deployed: "k3s cluster",
    },
    images: [],
  },
  backend: {
    versioning: {
      releasedOn: null,
      currentVersion: "0.0.9",
      updatedOn: null,
    },
    techInformation: {
      language: "Java 17",
      framework: "Spring Boot 2.7.1",
      logging: "Log4j2",
      metrics: "Spring Actuator",
      virtualization: "Docker",
      containerOS: "openjdk:17.0.2-slim",
      deployed: "k3s cluster",
      database: null,
      integrations: [],
    },
  },
};

class IdentityProjectData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "identity",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new IdentityProjectData();
